const colors = {
  primary: '#FF8A1F',
  danger: '#FB2424',
  black: '#000000',
  white: '#FFFFFF',
  gray: '#878787',
};

export { colors };
